import * as React from 'react'
import {observer} from 'mobx-react-lite'
import systemStore from '../../storage/SystemStore'
import {useEffect, useRef} from 'react'
import {Toast} from 'primereact/toast'

const Notification = () => {
  const toast = useRef(null);
  
  useEffect(() => {
    if (systemStore.message) {
      // toast(systemStore.message);
      toast.current.show({ severity: systemStore.messageType, detail: systemStore.message });
      systemStore.clearMessage()
    }
  }, [systemStore.message])
 
  return (
    <Toast ref={toast} />
  )
}

export default observer(Notification)
